import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { currency, displayDate } from '@/utils/format.utils';
import type { ColumnDef } from '@tanstack/vue-table';
import { ArrowUpDown } from 'lucide-vue-next';
import { h } from 'vue';
import { RouterLink } from 'vue-router';
import type { ModelSettlementReport } from '@layup/api-sdk';

export const settlementsTableColumns: ColumnDef<ModelSettlementReport>[] = [
  {
    accessorKey: 'batch',
    header: () => 'Batch No',
    enableSorting: false,
    cell: ({ getValue }) => {
      const batch = getValue() as string;
      return h('div', { class: 'font-medium' }, batch);
    },
  },
  {
    accessorKey: 'reference',
    header: () => 'Reference',
    enableSorting: false,
    cell: ({ row }) => {
      const rowData = row.original;
      const ref = rowData.reference;
      return h(
        RouterLink,
        { to: `/merchant/settlements/${rowData.id}`, class: 'font-medium text-brand-700 underline' },
        () => ref,
      );
    },
  },
  {
    accessorKey: 'settledAt',
    header: () => 'Date Settled',
    enableSorting: false,
    cell: ({ getValue }) => {
      const dateSettled = getValue() as string;
      return h('div', { class: 'font-medium' }, displayDate(dateSettled));
    },
  },
  {
    accessorKey: 'amount',
    header: () => 'Amount',
    enableSorting: false,
    cell: ({ getValue }) => {
      const settlementAmount = getValue() as string;
      return h('div', { class: 'font-medium' }, currency(settlementAmount));
    },
  },
  {
    accessorKey: 'batchType',
    header: () => 'Batch Type',
    enableSorting: false,
    cell: ({ getValue }) => {
      const batchType = getValue() as
        | 'ALL'
        | 'COMPLETED'
        | 'DEPOSITCOMPLETED'
        | 'COMPLETEDCANCELLED'
        | 'DEPOSITCOMPLETEDCANCELLED';

      const titles = {
        ALL: 'All',
        COMPLETED: 'Completed',
        COMPLETEDCANCELLED: 'Completed Cancelled',
        DEPOSITCOMPLETEDCANCELLED: 'Deposit Completed Cancelled',
        DEPOSITCOMPLETED: 'Deposit Completed',
      };

      return h(Badge, { class: 'text-xs', variant: 'info' }, () => titles[batchType]);
    },
  },
];
